import lazyImport from './lazy-import';

export default lazyImport;